import { render } from "./backup-modal.vue?vue&type=template&id=e0c2f0ee"
import script from "./backup-modal.vue?vue&type=script&lang=js"
export * from "./backup-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__